export const REFRESH_KIOSK_STATUSES_INTERVAL = 60000; // 1 minute

export const CHART_TITLE = {
  humidity: 'Humidity',
  temperature: 'Temperature (°C)',
  cpuUsage: 'CPU Usage (%)',
  memoryUsage: 'Memory Usage (%)',
};
export const SUPPORTED_CHARTS = Object.keys(CHART_TITLE);
